module.exports = __webpack_public_path__ + "static/img/carousel-1new.dc01424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/home/carousel-1new.jpg
// module id = cZPe
// module chunks = 15